import { graphql } from '@prophecy/graphql-types/graphql';
import { gql } from 'graphql-request';
export const projectHarmonizationPropertiesQuery = gql `
  query ProjectHarmonizationProperties($projectId: String!) {
    Project(uid: $projectId) {
      _id
      harmonizationProperties {
        status
      }
    }
  }
`;
export const updateHarmonizationStatusMutation = gql `
  mutation UpdateHarmonizationStatus($uid: String!, $status: String!) {
    updateHarmonizationStatus(uid: $uid, status: $status)
  }
`;
export const createHarmonizationProjectMutation = graphql(`
  mutation createHarmonizationProject(
    $name: String!
    $ownerUID: String!
    $mainBranch: String
    $language: BackEndCodeLanguage
    $forkMode: ForkMode!
    $dependencyProjectUIDs: [String!]
    $description: String
    $providerType: String
    $versionControlMode: VersionControlMode
    $isImport: Boolean
    $defaultDevelopmentBranch: String
    $defaultTransformationEntity: DefaultTransformationEntity
    $isOnboardingEntity: Boolean
    $harmonizationProperties: HarmonizationPropertiesInput
  ) {
    addProject(
      name: $name
      ownerUID: $ownerUID
      mainBranch: $mainBranch
      language: $language
      forkMode: $forkMode
      dependencyProjectUIDs: $dependencyProjectUIDs
      description: $description
      providerType: $providerType
      versionControlMode: $versionControlMode
      isImport: $isImport
      defaultDevelopmentBranch: $defaultDevelopmentBranch
      defaultTransformationEntity: $defaultTransformationEntity
      isOnboardingEntity: $isOnboardingEntity
      harmonizationProperties: $harmonizationProperties
    ) {
      _id
      name
    }
  }
`);
